import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  Box,
  LunchIcon,
  MassageIcon,
  RecreationalIcon,
  TransportIcon,
  WellbeingIcon
} from 'edenred-ui';

import { BenefitType } from '@epi-constants/benefitTypes';
import { IBenefitTile } from '@epi-models/pages/BenefitGroups';

import { BenefitTileCommon } from './BenefitTileCommon';

export const BenefitTile = ({ type, limit }: IBenefitTile) => {
  const { t } = useTranslation();
  const { primaryFrontColor } = useTheme();

  const benefitConfig: Record<string, { icon: ReactNode; title: string }> = {
    [BenefitType.Lunch]: {
      icon: <LunchIcon color={primaryFrontColor} />,
      title: t('home.benefits_tile.lunch.title')
    },
    [BenefitType.Recreational]: {
      icon: <RecreationalIcon color={primaryFrontColor} />,
      title: t('home.benefits_tile.recreational.title')
    },
    [BenefitType.Transport]: {
      icon: <TransportIcon color={primaryFrontColor} />,
      title: t('home.benefits_tile.transport.title')
    },
    [BenefitType.Massage]: {
      icon: <MassageIcon color={primaryFrontColor} />,
      title: t('home.benefits_tile.massage.title')
    },
    [BenefitType.Wellbeing]: {
      icon: <WellbeingIcon color={primaryFrontColor} />,
      title: t('home.benefits_tile.wellbeing.title')
    }
  };

  const benefit = benefitConfig[type.toLowerCase()];

  if (!benefit) {
    return <Box />;
  }

  return (
    <BenefitTileCommon
      icon={benefit.icon}
      title={benefit.title}
      limit={limit}
    />
  );
};
